import { useState } from 'react';
import Alert from '~/components/General/Alert';
import Button from '~/components/General/Button';
import Spinner from '~/components/General/Spinner';
import Files from '~/components/MyEnvironment/Files';
import { useCustomerTravelplanFiles } from '~/hooks/myEnvironment/useCustomerTravelplanFiles';
import useTranslation from '~/hooks/useTranslation';
import reservationFilesStyles from '~/styles/myEnvironment/reservation-files.module.css';

type Props = {
  travelplanId: number;
};

export default function ReservationFiles({
  travelplanId,
}: Props) {
  const [loadFiles, setLoadFiles] = useState(false);
  const translate = useTranslation();

  const {
    data,
    isFetching,
    error,
  } = useCustomerTravelplanFiles(travelplanId.toString(), loadFiles);

  if (!loadFiles) {
    return (
      <div className={reservationFilesStyles.viewFilesPlaceholder}>
        <Button
          className={reservationFilesStyles.viewFilesButton}
          onClick={() => setLoadFiles(true)}
        >
          {translate('myEnvironment.reservation.view_files')}
        </Button>
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        type="danger"
        error={error}
      />
    );
  }

  if (isFetching || !data) {
    return (
      <div className={reservationFilesStyles.viewFilesPlaceholder}>
        <Spinner />
      </div>
    );
  }

  if (!data.files.length) {
    return (
      <div className={reservationFilesStyles.viewFilesPlaceholder}>
        <p>{translate('myEnvironment.reservation.no_files')}</p>
      </div>
    );
  }

  return (
    <Files
      files={data.files}
    />
  );
}
